import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import {
  Container, Spinner, Table,
} from 'react-bootstrap';
// import UnifyButton from '../../../../components/Button';
// import { N0 } from '../../../../components/Colors';
import axios from 'axios';
import { Loader } from './styles';
import config from '../../../../config';
import { getQueryParam } from '../helper/urlHelper';

const List = ({ appliedFilter }) => {
  const [loading, setLoading] = useState(true);
  const [listKum, setListKum] = useState([]);

  const fetch = () => {
    setLoading(true);
    axios.get(`${config.API_BASE_URL}api/kuliah_umum/history/${getQueryParam(appliedFilter)}`, {
      headers: {
        accept: 'application/json',
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
      },
    })
      .then((resp) => {
        setListKum(resp?.data);
        setLoading(false);
      });
  };

  useEffect(() => {
    if (appliedFilter) {
      fetch();
    }
  }, [appliedFilter]);

  if (loading) {
    return (
      <Loader>
        <Spinner animation="border" />
      </Loader>
    );
  }
  return (
    <>
      <Container>
        <Table className="mt-4" striped bordered hover responsive>
          <thead>
            <tr>
              <th>Nama Kuliah Umum</th>
              <th>Narasumber</th>
              <th>Penyelenggara</th>
              <th>Waktu</th>
              <th>Tempat</th>
            </tr>
          </thead>
          <tbody>
            {listKum.map((value) => (
              <tr>
                <td>{value.nama_kegiatan}</td>
                <td>{value.pembicara}</td>
                <td>{value.penyelenggara}</td>
                <td>{value.tanggal}</td>
                <td>
                  {value.lokasi}
                </td>

              </tr>
            ))}
          </tbody>
        </Table>
      </Container>
    </>
  );
};

List.propTypes = {
  appliedFilter: PropTypes.shape({
    jenis_kegiatan: '', nama_kegiatan: 0, tanggal: '', penyelenggara: '',
  }).isRequired,
};

export default List;
